import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type TInitialCommon = {
  blockHrActions: boolean;
};

const initialState: TInitialCommon = {
  blockHrActions: false,
};

export const commonSlice = createSlice({
  name: 'ui/common',
  initialState,
  reducers: {
    blockHrActions(state, { payload }: PayloadAction<boolean>) {
      return { ...state, blockHrActions: payload };
    },
  },
});

const selectCommon = (state: RootState) => state.ui.common;

export const selectors = { selectCommon };
export const actions = commonSlice.actions;
export const reducer = commonSlice.reducer;
